<template>
    <section class="odocs-spaced">
        <p>
            <o-tag label="Default" />
            <o-tag label="Primary" variant="primary" />
            <o-tag label="Secondary" variant="secondary" />
            <o-tag label="Success" variant="success" />
            <o-tag label="Info" variant="info" />
            <o-tag label="Warning" variant="warning" />
            <o-tag label="Danger" variant="danger" />
        </p>
    </section>
</template>
